/* eslint-disable no-param-reassign */
import { produce } from 'immer';

import BASKET_ANALYZE_ACTION_TYPES, {
  BasketAnalyzeActionTypes,
} from 'actionTypes/basketAnalyze';
import { API_STATUS } from 'constants/enums';
import { BasketAnalyzeState } from 'types/basketAnalyze';

export const initialState: BasketAnalyzeState = {
  pnlTab: {
    selectedTargetPrice: 0,
    selectedTargetDate: 0,
    selectedTargetDateIndex: 0,
    selectedRows: [],
    // Added this for getting the selected target price which has data
    // if we use selectedTargetPrice it updates based on UI interactions
    // so before we have the updated data for the selectedTargetPrice in the UI
    // it shows fallback values (ex: pnl tab - est price column- showing zero for changed target price on api call)
    lastResolvedTargetPrice: 0,
  },
  basketAnalytics: {
    data: null,
    apiStatus: API_STATUS.INITIAL,
    errorMessage: null,
    isAnalyticsApiRefetching: false,
  },
  isBasketAnalyzeLoading: false,
};

const basketAnalyzeReducer = produce((draft, action) => {
  switch (action.type) {
    case BASKET_ANALYZE_ACTION_TYPES[BasketAnalyzeActionTypes.BASKET_ANALYTICS].LOAD: {
      draft.basketAnalytics.apiStatus = API_STATUS.LOADING;
      draft.basketAnalytics.isAnalyticsApiRefetching =
        action.options.isAnalyticsApiRefetching;
      break;
    }
    case BASKET_ANALYZE_ACTION_TYPES[BasketAnalyzeActionTypes.BASKET_ANALYTICS].SUCCESS: {
      draft.basketAnalytics.apiStatus = API_STATUS.SUCCESS;
      draft.basketAnalytics.data = action.result.result;
      draft.basketAnalytics.isAnalyticsApiRefetching = false;
      draft.isBasketAnalyzeLoading = false;
      draft.pnlTab.lastResolvedTargetPrice = action.options.requestedTargetPrice;
      break;
    }
    case BASKET_ANALYZE_ACTION_TYPES[BasketAnalyzeActionTypes.BASKET_ANALYTICS].FAIL: {
      draft.basketAnalytics.apiStatus = API_STATUS.ERROR;
      // we are not showing the error message  instead fallback message is shown
      draft.basketAnalytics.errorMessage = null;
      draft.basketAnalytics.isAnalyticsApiRefetching = false;
      draft.isBasketAnalyzeLoading = false;
      draft.pnlTab.lastResolvedTargetPrice = 0;
      break;
    }
    case BasketAnalyzeActionTypes.BASKET_ANALYZE_LOADING: {
      draft.isBasketAnalyzeLoading = action.payload;
      break;
    }
    case BasketAnalyzeActionTypes.BASKET_ANALYTICS_PNL_TAB_SELECTED_TARGET_PRICE: {
      draft.pnlTab.selectedTargetPrice = action.payload;
      break;
    }
    case BasketAnalyzeActionTypes.BASKET_ANALYTICS_PNL_TAB_SELECTED_TARGET_DATE: {
      draft.pnlTab.selectedTargetDate = action.payload.selectedPnlTableTargetDate;
      draft.pnlTab.selectedTargetDateIndex =
        action.payload.selectedPnlTableTargetDateIndex;
      break;
    }

    case BasketAnalyzeActionTypes.BASKET_ANALYZE_PNL_TABLE_TAB_SELECTED_ROWS: {
      draft.pnlTab.selectedRows = action.payload.selectedRowIds;
      draft.pnlTab.selectedTargetDate = action.payload.selectedTargetDate;
      draft.pnlTab.selectedTargetDateIndex = action.payload.targetDateMax;
      break;
    }
    case BasketAnalyzeActionTypes.BASKET_ANALYTICS_PNL_TAB_LAST_RESOLVED_TARGET_PRICE: {
      draft.pnlTab.lastResolvedTargetPrice = action.payload;
      break;
    }
    default:
      break;
  }
}, initialState);

export default basketAnalyzeReducer;
